<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Add new offer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('MESSAGES.Offer image')"
            @selectImage="selectImage"
            required
          />

          <div class="col-12">
            <router-link
              class="btn btn-primary"
              style="
                background: var(--main_theme_clr);
                color: var(--white_clr);
                border-color: var(--main_theme_clr);
              "
              :to="{
                path: '/providers/create',
                query: { type: 'offer_provider' },
              }"
            >
              {{ $t("MESSAGES.Add another provider") }}
            </router-link>
          </div>

          <base-select-input
            col="12"
            :optionsList="productCategories"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model="data.provider_id"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer name arabic')"
            v-model.trim="data.name"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Offer name english')"
            v-model.trim="data.nameEn"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.Offer description arabic')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('MESSAGES.Offer description english')"
            v-model.trim="data.descProdEn"
            required
          />

          <base-input
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Offer start date')"
            v-model.trim="data.start_date"
            required
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Offer end date')"
            v-model.trim="data.end_date"
            required
          />

          <base-text-editor
            col="6"
            type="time"
            :placeholder="$t('MESSAGES.terms of use arabic')"
            v-model.trim="data.usage_policy_ar"
            required
          />
          <base-text-editor
            col="6"
            type="time"
            :placeholder="$t('MESSAGES.terms of use english')"
            v-model.trim="data.usage_policy_en"
          />
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
          />
          <div class="col-12 mb-3 input_wrapper top_label select_wrapper">
            <GmapAutocomplete
              @place_changed="setPlace"
              @keyup.enter.stop="setPlace"
              :placeholder="$t('MESSAGES.search_place')"
            />
          </div>
          <div class="col-12">
            <gmap-map
              :center="{
                lat: data.lat ?? 24.7136,
                lng: data.lng ?? 46.6753,
              }"
              :zoom="12"
              style="width: 100%; height: 300px"
              @click="setLocation($event, index)"
            >
              <gmap-marker
                v-if="data.lat && data.lng"
                :position="{
                  lat: data.lat,
                  lng: data.lng,
                }"
              />
            </gmap-map>
            <v-btn @click="resetButton" color="primary" class="mt-2">{{
              $t("PLACEHOLDERS.reset_btn")
            }}</v-btn>
          </div>

          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "CreateProduct",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      additionalImages: [],
      // End:: Loader Control Data

      file: null,
      fileType: "",
      productCategories: [],

      // Start:: Data Collection To Send
      data: {
        imgUrls: [],
        image: {
          path: null,
          file: null,
        },
        lat: null,
        lng: null,
        name: null,
        nameEn: null,
        usage_policy_en: null,
        usage_policy_ar: null,
        address: "",
        start_date: null,
        end_date: null,
        provider_id: null,
        descProd: null,
        descProdEn: null,
        product_category_id: null,
        price: 0,
        quantity: 0,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
      },
      // End:: Data Collection To Send
      cats: [],
      subCats: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    mostPaids() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.yes"),
          value: true,
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.no"),
          value: false,
        },
      ];
    },
  },

  methods: {
    resetButton() {
      this.data.lat = null;
      this.data.lng = null;
    },
    setLocation(event) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      this.data.lat = lat;
      this.data.lng = lng;

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.data.address = results[0].formatted_address;
        } else {
          this.data.address = "--";
        }
      });
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        this.data.lat = this.currentPlace.geometry.location.lat();
        this.data.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.data.imgUrls, index);
    },
    async getProductCategories() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "providers?limit=0&page=0&is_active=1",
        });
        this.productCategories = res.data.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.name = this.data.name.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.name) {
        REQUEST_DATA.append("name[ar]", this.data.name);
      }
      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }
      if (this.data.descProd) {
        REQUEST_DATA.append("description[ar]", this.data.descProd);
      }
      if (this.data.descProdEn) {
        REQUEST_DATA.append("description[en]", this.data.descProdEn);
      }
      if (this.data.start_date) {
        REQUEST_DATA.append("start_date", this.data.start_date);
      }
      if (this.data.end_date) {
        REQUEST_DATA.append("end_date", this.data.end_date);
      }
      if (this.data.usage_policy_ar) {
        REQUEST_DATA.append("privacy[ar]", this.data.usage_policy_ar);
      }
      if (this.data.usage_policy_en) {
        REQUEST_DATA.append("privacy[en]", this.data.usage_policy_en);
      }
      if (this.data.provider_id) {
        REQUEST_DATA.append("provider_id", this.data.provider_id?.id);
      }
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      if (this.data.lat) REQUEST_DATA.append("lat", this.data.lat);
      if (this.data.lng) REQUEST_DATA.append("lng", this.data.lng);
      REQUEST_DATA.append("address", this.data.address);

      try {
        await this.$axios({
          method: "POST",
          url: `offers`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/offers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    this.getProductCategories();
  },
};
</script>
